import { render, staticRenderFns } from "./DeliveryNew.vue?vue&type=template&id=634b1ff8&"
import script from "./DeliveryNew.vue?vue&type=script&lang=js&"
export * from "./DeliveryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports